import { defineMessages } from 'react-intl';

export default defineMessages({
    searchContactTitle: {
        id: 'gateway.views.additional-contacts.Search Address Book',
        defaultMessage: 'Search Address Book',
    },
    additionalContactType: {
        id: 'gateway.views.additional-contacts.ContactType',
        defaultMessage: 'Type',
    },
    additionalPerson: {
        id: 'gateway.views.additional-contacts.Person',
        defaultMessage: 'Person',
    },
    additionalCompany: {
        id: 'gateway.views.additional-contacts.Company',
        defaultMessage: 'Company',
    },
    addNew: {
        id: 'gateway.views.additional-contacts.Add New',
        defaultMessage: 'Add New',
    },
    cancelSearch: {
        id: 'gateway.views.additional-contacts.Cancel',
        defaultMessage: 'Cancel',
    },
    searchAdditionalContact: {
        id: 'gateway.views.additional-contacts.Search',
        defaultMessage: 'Search',
    },
    additionalContactFirstName: {
        id: 'gateway.views.additional-contacts.FirstName',
        defaultMessage: 'First Name',
    },
    additionalContactLastName: {
        id: 'gateway.views.additional-contacts.LastName',
        defaultMessage: 'Last Name',
    },    
    contactHeaderName: {
        id: 'gateway.views.additional-contacts.Name',
        defaultMessage: 'Name'
    },
    contactHeaderAddress: {
        id: 'gateway.views.additional-contacts.Address',
        defaultMessage: 'Address'
    },
    noContacts: {
        id: 'gateway.views.additional-contacts.No results found!',
        defaultMessage: 'No Contacts'
    }
});
